const trialRouteAccess = trialRouteAccessService =>
  trialRouteAccessService();

export const trialRouteAccessResolve = {
  trialRouteAccess: ['trialRouteAccessService', trialRouteAccess],
};
